import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#AF0100"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M11.004 6c0 2.943.278 3.966 1.956 3.966 1.677 0 2.136-1.483 1.995-3.966h-3.951Z"
          clipRule="evenodd"
        />
        <Path
          fill="#AF0100"
          fillRule="evenodd"
          d="M13.05 7.7c.47 0 .85-.448.85-1s-.38-1-.85-1-.85.448-.85 1 .38 1 .85 1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M11.397 9.157c.299.667.821 1 1.568 1 .742 0 1.266-.329 1.574-.987l-3.142-.013Z"
          clipRule="evenodd"
        />
        <Path
          fill="#82B2CB"
          d="m11.81 7.515-.28-.696a3.976 3.976 0 0 1 1.481-.31c.475 0 .969.105 1.48.31l-.278.696a3.235 3.235 0 0 0-1.202-.255c-.374 0-.774.084-1.201.255Z"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M12.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#8A4E22"
          fillRule="evenodd"
          d="M12.8 8.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#AF0100"
          fillRule="evenodd"
          d="M12 8.4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM13.7 8.4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM13.35 9.5c.193 0 .35-.224.35-.5s-.157-.5-.35-.5c-.193 0-.35.224-.35.5s.157.5.35.5ZM12.15 9.5c.193 0 .35-.224.35-.5s-.157-.5-.35-.5c-.193 0-.35.224-.35.5s.157.5.35.5Z"
          clipRule="evenodd"
        />
      </G>
      <G clipPath="url(#c)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="c">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
